import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import AurPaginationPro from '../../../common/aur-pagination-pro/AurPaginationPro';

const PaginationPro: React.FC = () => {
  const [startIndex, setStartIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);

  const handlePageChange = (page: number) => {
    setStartIndex(page);
  };

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Pagination Pro</h1>
        <div>
          The Pagination component enables the user to select a specific page
          from a range of pages.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurPaginationPro
            totalItems={500}
            itemsPerPage={itemsPerPage}
            startIndex={startIndex}
            onPageChange={handlePageChange}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default PaginationPro;
